import React from 'react';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <div className="policy-header">
          <h1>Privacy Policy — TRYON</h1>
          <p className="last-updated">Last Updated: 29/12/2025</p>
        </div>

        <div className="policy-intro">
          <p>
            TRYON, We respect your privacy and are committed to protecting your personal information.
            This policy explains how we collect, use, and safeguard your data while you engage with our
            website and services.
          </p>
        </div>

        <div className="policy-section">
          <h2>1. Information We Collect</h2>
          <p>We may collect the following data:</p>
          <ul>
            <li>Name, contact number, email address.</li>
            <li>Shipping and billing addresses.</li>
            <li>Order and payment details.</li>
            <li>Device & browsing information (cookies, IP address, analytics).</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>2. How We Use Your Information</h2>
          <p>Your information helps us:</p>
          <ul>
            <li>Process and deliver orders.</li>
            <li>Provide customer support and updates.</li>
            <li>Improve website performance & product offerings.</li>
            <li>Prevent fraudulent activities.</li>
            <li>Send promotional messages (only with your consent).</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Payment Security</h2>
          <p>
            All online payments are processed securely through trusted payment gateways. TRYON does
            not store or access your complete banking/payment details.
          </p>
        </div>

        <div className="policy-section">
          <h2>4. Cookies & Tracking</h2>
          <p>
            We use cookies to enhance your browsing experience and analyze website traffic. You may
            disable cookies in your browser settings, though some features may not function properly.
          </p>
        </div>

        <div className="policy-section">
          <h2>5. Third-Party Sharing</h2>
          <p>We only share necessary information with trusted service providers such as:</p>
          <ul>
            <li>Delivery & logistics partners</li>
            <li>Payment processors</li>
          </ul>
          <p>They are obligated to protect your data and use it only for providing agreed services.</p>
        </div>

        <div className="policy-section">
          <h2>6. Data Protection</h2>
          <p>
            We implement technical and organizational measures to protect your personal data from
            unauthorized access, loss, or misuse.
          </p>
        </div>

        <div className="policy-section">
          <h2>7. Your Rights</h2>
          <p>You may request:</p>
          <ul className="rights-list">
            <li>✔ Access to your personal data</li>
            <li>✔ Correction or deletion of your details</li>
            <li>✔ To unsubscribe from promotional messages</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>8. Changes to Policy</h2>
          <p>
            TRYON reserves the right to update this Privacy Policy at any time. Revised updates will be
            posted on this page.
          </p>
        </div>

        <div className="policy-section">
          <h2>9. Contact</h2>
          <p>For any privacy concerns, reach us at:</p>
          <div className="contact-info">
            <p>📧 Email: <a href="mailto:tyon.wear02@gmail.com">tyon.wear02@gmail.com</a></p>
            <p>📞 Phone: <a href="tel:+919265490049">+91 9265490049</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
